import {
    SELL_SET_ORDER_LOOKUP_DIALOG_STATUS,
    ORDER_LOOKUP_DIALOG_SHOW_AND_REDIRECT_TO_ORDER,
    ORDER_LOOKUP_DIALOG_RESET_AUTO_REDIRECT,
    SELL_REDIRECT_TO_ORDER,
} from 'store/actions/orderLookup.action'

export type AutoRedirectToOrderParams = {
    orderID: string | undefined
    // For Redirect to Table Order
    tableID: string | undefined
    tableGroupID: string | undefined
    type: 'online_order' | 'today' | 'pos'
}

interface OrderLookupState {
    isOpen: boolean
    redirectToOrder: AutoRedirectToOrderParams | undefined
}
const initialState: OrderLookupState = {
    isOpen: false,
    redirectToOrder: undefined,
}
export type IOrderLookupAction =
    | {
          type: 'SELL_SET_ORDER_LOOKUP_DIALOG_STATUS'
          payload: boolean
      }
    | {
          type: 'ORDER_LOOKUP_DIALOG_SHOW_AND_REDIRECT_TO_ORDER'
          payload: AutoRedirectToOrderParams
      }
    | {
          type: 'ORDER_LOOKUP_DIALOG_RESET_AUTO_REDIRECT'
      }
    | {
          type: 'SELL_REDIRECT_TO_ORDER'
          payload: AutoRedirectToOrderParams
      }
export default function reducer(
    state: OrderLookupState = initialState,
    action: IOrderLookupAction,
): OrderLookupState {
    switch (action.type) {
        case SELL_SET_ORDER_LOOKUP_DIALOG_STATUS: {
            return {
                ...state,
                isOpen: action.payload,
            }
        }
        case ORDER_LOOKUP_DIALOG_SHOW_AND_REDIRECT_TO_ORDER: {
            return {
                ...state,
                isOpen: true,
                redirectToOrder: action.payload,
            }
        }
        case ORDER_LOOKUP_DIALOG_RESET_AUTO_REDIRECT: {
            return {
                ...state,
                redirectToOrder: undefined,
            }
        }
        case SELL_REDIRECT_TO_ORDER: {
            const loadedOrder = action.payload
            return {
                ...state,
                redirectToOrder: loadedOrder,
            }
        }
        default:
            return state
    }
}
